import { batchHref, deskHref } from './links'

export type DeskLink = { to: string; label: string }

/** The left-hand links, in order. */
export function deskNav(role: string): DeskLink[] {
  void role // every role sees the same links today
  return [
    { to: deskHref(), label: 'Activity' },
    { to: batchHref(), label: 'Mail Order Batch' },
    { to: deskHref('search'), label: 'Find a member' },
  ]
}

/** Where the footer's back link goes; null for a desk account, which signs out instead. */
export function deskFooterLink(role: string): DeskLink | null {
  if (role === 'admin') return { to: '/', label: 'Back to the AAMCirc console' }
  if (role === 'operator') return { to: '/support', label: 'Back to the support desk' }
  return null
}
